/**
 * POS Receipts Hook
 *
 * React Query hook for fetching POS receipts.
 */

import { useQuery } from '@tanstack/react-query';
import { posSalesService } from '../services/pos-sales.service';
import type { PosReceiptsQueryParams } from '@bstock/shared';

export function usePosReceipts(params: PosReceiptsQueryParams) {
  return useQuery({
    queryKey: ['pos-receipts', params],
    queryFn: () => posSalesService.listReceipts(params),
  });
}

export function usePosReceiptDetail(receiptId: string | null) {
  return useQuery({
    queryKey: ['pos-receipt', receiptId],
    queryFn: () => posSalesService.getReceipt(receiptId!),
    enabled: !!receiptId,
  });
}
